import React, { useState, useEffect } from 'react';
import './style.css';
import logotipo from '../../imagens/logo.svg';
import { CiSearch, CiShop, CiUser, CiCalendarDate, CiPhone } from "react-icons/ci";
import { Tooltip } from 'antd';
import { Method_POST_CERTIFICADO } from '../../service/api';
import { ConsultarBio, SouCliente } from './ConsultarBio';
import { DadosEmpresa } from './DadosEmpresa';
import { toast } from 'react-toastify';

{/**

    Assim que o usuário terminar de digitar o CNPJ ele vai bater na API de buscar na base de clientes se o CNPJ existe;

    Se existir, ele vai preencher os campos de Nome Completo e Razão Social automaticamente;

    O botão de Consultar Bio só vai aparecer se o retorno da API for false e habilitar o campo para ele digitar a CNH ou RG;

   */}

const TravelzoForm = () => {

  const initialFormData = {
    cnpj: '',
    cpf: '',
    dataNascimento: '',
    nome: '',
    whatsapp: '',
    nomeEmpresa: '',
    documento: '',
    tipoDocumento: 'cnh',
    email: ''
  };

  const [formData, setFormData] = useState(initialFormData);

  const [isVisible, setIsVisible] = useState(false);
  const [tipoCliente, setTipoCliente] = useState('souCliente');
  const [statusConsulta, setStatusConsulta] = useState(false);
  const [isbiometria, setIsBiometria] = useState(false);
  const [loadingBiometria, setLoadingBiometria] = useState(false);
  const [loadingCheckout, setLoadingCheckout] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // const [tipoDocumento, setTipoDocumento] = useState('cnh');

  const resetForm = () => {
    setFormData(initialFormData);
    setTipoCliente('souCliente');
    setStatusConsulta(false);
    setIsBiometria(false);
    setLoadingBiometria(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(value)
    let valorFormatado = value;

    if (name === 'nome') {
      valorFormatado = value;
    }

    if (name === 'dataNascimento') {
      valorFormatado = formatarData(value);
    }

    if (name === 'cpf') {
      valorFormatado = formatarCpf(value);
    }

    if (name === 'cnpj') {
      valorFormatado = formatarCnpj(value);
    }

    if (name === 'whatsapp') {
      valorFormatado = formatarCelular(value);
    }

    if (name === 'documento') {
      valorFormatado = value;
    }
    console.log(valorFormatado)
    setFormData({
      ...formData,
      [name]: valorFormatado
    });
  };

  function formatarData(valor) {
    valor = valor.replace(/\D/g, '');
    valor = valor.slice(0, 8);

    if (valor.length >= 5) {
      return valor.replace(/(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3');
    } else if (valor.length >= 3) {
      return valor.replace(/(\d{2})(\d{0,2})/, '$1/$2');
    }

    return valor;
  }

  function formatarCpf(valor) {
    valor = valor.replace(/\D/g, '');
    valor = valor.slice(0, 11);

    return valor
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }

  function formatarCnpj(valor) {
    valor = valor.replace(/\D/g, '');
    valor = valor.slice(0, 14);

    return valor
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }

  function formatarCelular(valor) {
    valor = valor.replace(/\D/g, '');
    valor = valor.slice(0, 11);

    if (valor.length > 6) {
      return valor.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
    }

    if (valor.length > 2) {
      return valor.replace(/(\d{2})(\d{0,5})/, '($1) $2');
    }

    return valor;
  }

  function limparDocumento(doc) {
    if (typeof doc !== 'string') {
      return '';
    }
    return doc.replace(/\D/g, '');
  }

  const handleConsultarBio = async () => {
    if (loadingBiometria) return; // 🔒 trava lógica REAL

    setLoadingBiometria(true); // ⬅️ ISSO estava faltando
    try {
      const url = "/biometria";
      const payload = {
        cnpj: limparDocumento(formData.cnpj),
        cpf: limparDocumento(formData.cpf),
        dataNascimento: formData.dataNascimento.replace(/\//g, ''),
      };

      toast.loading("Consultando biometria...", { toastId: "bio" });

      console.log("Payload enviado:", payload);

      const response = await Method_POST_CERTIFICADO(url, payload);

      toast.dismiss("bio");

      console.log("Resposta da biometria:", response);

      if (!response?.cliente) {
        toast.info(
          "Funcionalidade para não clientes estará disponível em breve 🚧",
          { toastId: "nao-cliente" }
        );
        resetForm();
        return;
      }

      if (response.biometria) {
        setStatusConsulta('cliente-com-biometria');
        //formData.tipoDocumento('rg')
        toast.success("Biometria encontrada!");
        setIsBiometria(true);
      } else {
        setStatusConsulta('cliente-sem-biometria');
        setIsBiometria(false);
        toast.info("Cliente sem biometria.");
      }

      const cliente = response.cliente;

      // 🔒 força CNH sem resetar tudo
      setFormData(prev => ({
        ...prev,
        tipoDocumento: 'cnh',
        nomeEmpresa: cliente.nome
      }));
    } catch (error) {
      toast.dismiss("bio");
      toast.error("Erro ao consultar biometria.");
      console.error("Erro ao consultar biometria", error);
    } finally {
      setLoadingBiometria(false);
      // resetForm();
    }
  };

  const gerarLinkDePagamento = async () => {
    if (loadingCheckout) return;

    if (!formData.whatsapp) {
      toast.warn('Informe o WhatsApp.');
      return;
    }

    if (!formData.documento) {
      toast.warn('Informe o número do documento.');
      return;
    }

    setLoadingCheckout(true);

    toast.loading('Gerando link de pagamento...', { toastId: 'checkout' });

    try {
      const url = "/checkout"
      const payload = {
        cnpj: limparDocumento(formData.cnpj),
        cpf: limparDocumento(formData.cpf),
        dataNascimento: formData.dataNascimento.replace(/\//g, ''),
        whatsapp: formData.whatsapp.replace(/\D/g, ''),
        documento: formData.documento,
        tipoDoc: formData.tipoDocumento,
        nomeCompleto: formData.nome,
        email: formData.email
      };

      console.log("Payload enviado:", payload);

      const response = await Method_POST_CERTIFICADO(url, payload);

      toast.dismiss('checkout');
      toast.success('Link de pagamento gerado com sucesso!');
      resetForm();

      console.log("PIX:", response);

    } catch (error) {
      toast.dismiss('checkout');
      toast.error('Erro ao gerar o pagamento.');
      console.error("Erro ao gerar o pix.", error);
    } finally {
      setLoadingCheckout(false);
    }
  };


  /**finally{
      setFormData(null)
    } */

  const handleDoc = (evt) => {
    const selecDoc = evt.target.value
    if (selecDoc === "rg") {
      setFormData(prev => ({
        ...prev,
        tipoDocumento: "rg"
      }))
    } else {
      setFormData(prev => ({
        ...prev,
        tipoDocumento: "cnh"
      }))
    }
  };


  return (
    <div className="main-container">
      <div className={`card-certificado ${isVisible ? 'fade-in' : ''}`}>

        {/* Lado Esquerdo - Hero */}
        <div className="hero-section">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="logo">
              <img src={logotipo} alt="Travelzo Logo" />
            </div>

            <div className="hero-text">
              <p className="subtitle">SEGURANÇA PARA O SEU NEGÓCIO</p>
              <h1>Adquira agora seu <span style={{ color: "#07bc0c" }}>Certificado Digital</span> e resolva tudo online, <br /> sem burocracia</h1>
              <p className="description">Atendemos clientes em mais de 1.000 municípios em todos os estados do Brasil..</p>
            </div>

            <div className="hero-buttons">
              <button
                className={tipoCliente === 'souCliente' ? 'btn-primary' : 'btn-outline'}
                onClick={() => setTipoCliente('souCliente')}
              >
                Já sou Cliente
              </button>

              {/* <button
                className={tipoCliente === 'queroSerCliente' ? 'btn-primary' : 'btn-outline'}
                onClick={() => setTipoCliente('queroSerCliente')}
              >
                Quero ser Cliente
              </button> */}
            </div>
          </div>
        </div>

        {/* Lado Direito - Formulário */}
        <div className="form-section">
          <nav className="navbar">
            <div className="nav-links">
              <a
                href="#"
                className={tipoCliente === 'souCliente' ? 'active' : ''}
                onClick={(e) => { e.preventDefault(); setTipoCliente('souCliente'); }}
              >
                {/* Já sou Cliente */}
              </a>
              {/* <a
                href="#"
                className={tipoCliente === 'queroSerCliente' ? 'active' : ''}
                onClick={(e) => { e.preventDefault(); setTipoCliente('queroSerCliente'); }}
              >
                Quero ser Cliente
              </a> */}
            </div>
          </nav>

          <div>
            <h2 className="form-title">Associar <br /> Cliente ao Certificado<span>.</span></h2>

            <form onSubmit={(e) => e.preventDefault()}>

              <div className='scrrol-y-form'>

                {/* RENDERIZAÇÃO CONDICIONAL - JÁ SOU CLIENTE */}
                {tipoCliente === 'souCliente' && (
                  <div id='souCliente'>
                    <div id='souClienteForm-stpe-1' className="form-step">
                      <ConsultarBio handleChange={handleChange} formData={formData} handleConsultarBio={handleConsultarBio} loadingBiometria={loadingBiometria} />
                      {statusConsulta && statusConsulta !== 'sem-cliente' && (
                        <>
                          <DadosEmpresa handleChange={handleChange} formData={formData} handleDoc={handleDoc} statusConsulta={statusConsulta} tipoCliente={tipoCliente} gerarLinkDePagamento={gerarLinkDePagamento} loadingCheckout={loadingCheckout} />
                        </>
                      )}
                    </div>
                  </div>
                )}

                {/* RENDERIZAÇÃO CONDICIONAL - QUERO SER CLIENTE */}
                {tipoCliente === 'queroSerCliente' && (
                  <div id='queroSerCliente'>
                    <div className="form-step slide-up">
                      <h3>Cadastro de Novo Cliente</h3>
                      <p>Preencha os dados para começar.</p>
                      {/* <ConsultarBio handleChange={handleChange} formData={formData} handleConsultarBio={handleConsultarBio} /> */}
                      <DadosEmpresa handleChange={handleChange} formData={formData} handleDoc={handleDoc} statusConsulta={statusConsulta} tipoCliente={tipoCliente} gerarLinkDePagamento={gerarLinkDePagamento} />
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div >
    </div >
  );
};

export default TravelzoForm;